export default __webpack_public_path__ + "static/media/powerExperienceIcon2.fe1cd079.webp";